export default function AdaptZipCode(zipCode: string): string {
    if (zipCode.indexOf(' ') == -1 && zipCode.length == 5) {
        zipCode = zipCode.substring(0, 3) + ' ' + zipCode.substr(3)
    }

    return zipCode;
} 